import React from 'react'
import {NoRows} from "../../../layout/Table/NoRows";
import {TableRow} from "./TableRow";

const TableBody = (props) => {

  const renderRows = () => {
    if (!Array.isArray(props.items) || props.items === 0 || props.items.length === 0) {
      return <NoRows colSpan="8"/>;
    }

    return props.items.map(renderRow)
  }

  const renderRow = (item, index) => {
    return (
      <TableRow
        key = { index }
        item={ item }
        actionCallback={ props.actionCallback }
        index= { index }
      />
    )
  }

  return (
    <tbody>
    { renderRows() }
    </tbody>
  )
}

export { TableBody }
